import { create } from 'zustand';

interface IncomingCall {
  callId: string;
  isRepeatCaller: boolean;
  isNew: boolean;
  leadId?: string;
  receivedAt: Date;
}

interface ActiveCall {
  id: string;
  agentId: string;
  status: string;
  startedAt?: Date;
}

interface CallStore {
  incomingCalls: IncomingCall[];
  activeCall: ActiveCall | null;
  callTimer: number;
  isOnCall: boolean;

  addIncomingCall: (call: Omit<IncomingCall, 'receivedAt'>) => void;
  dismissIncomingCall: (callId: string) => void;
  setActiveCall: (call: ActiveCall) => void;
  endCall: (callId: string) => void;
  updateTimer: (seconds: number) => void;
}

export const useCallStore = create<CallStore>((set) => ({
  incomingCalls: [],
  activeCall: null,
  callTimer: 0,
  isOnCall: false,

  addIncomingCall: (call) =>
    set(state => ({
      incomingCalls: [
        { ...call, receivedAt: new Date() },
        ...state.incomingCalls.slice(0, 9), // Keep max 10
      ],
    })),

  dismissIncomingCall: (callId) =>
    set(state => ({
      incomingCalls: state.incomingCalls.filter(c => c.callId !== callId),
    })),

  setActiveCall: (call) =>
    set({ activeCall: { ...call, startedAt: new Date() }, isOnCall: true, callTimer: 0 }),

  endCall: (callId) =>
    set(state => ({
      activeCall: state.activeCall?.id === callId ? null : state.activeCall,
      isOnCall: state.activeCall?.id === callId ? false : state.isOnCall,
      callTimer: 0,
    })),

  updateTimer: (seconds) => set({ callTimer: seconds }),
}));
